import { render, staticRenderFns } from "./UserAccountBillingHistoryCellRendererAmount.vue?vue&type=template&id=6b7887d0&"
import script from "./UserAccountBillingHistoryCellRendererAmount.vue?vue&type=script&lang=js&"
export * from "./UserAccountBillingHistoryCellRendererAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports